<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="an"> </p>
<p class="FM-Head-fmh-1"><span href="#/xhtml/contents#c_an" title="Link target outside of Sample">Author’s Note</span></p>
<p class="FM-Text-fmtx">This is a true story, though some names and details have been changed.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authorsnote.vue?a03b46ec